var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { filterAtom, searchModeAtom, searchQueryAtom, } from '@/screens/SearchScreen/atoms';
import ToastUtils from '@/utils/ToastUtils';
import useAppComponents from './useAppComponents';
export function useToggleAccessibilityInfoRequest(listQueryKey) {
    const { api } = useAppComponents();
    const queryClient = useQueryClient();
    const { text, location, useCameraRegion } = useAtomValue(searchQueryAtom);
    const { sortOption, scoreUnder, hasSlope, isRegistered } = useAtomValue(filterAtom);
    const searchMode = useAtomValue(searchModeAtom);
    const { mutate, isPending } = useMutation({
        mutationFn: (_a) => __awaiter(this, [_a], void 0, function* ({ currentIsRequested, placeId, }) {
            if (currentIsRequested) {
                return yield api.deletePlaceAccessibilityInfoRequestPost({ placeId });
            }
            else {
                return yield api.createPlaceAccessibilityInfoRequestPost({ placeId });
            }
        }),
        onMutate: (variables) => __awaiter(this, void 0, void 0, function* () {
            if (variables.searchQueryKey === undefined) {
                return;
            }
            yield queryClient.cancelQueries({
                queryKey: variables.searchQueryKey,
            });
            const previousSearchData = queryClient.getQueryData(variables.searchQueryKey);
            queryClient.setQueryData(variables.searchQueryKey, (oldData) => {
                if (!oldData)
                    return oldData;
                const toggleItem = (item) => item.place.id === variables.placeId
                    ? Object.assign(Object.assign({}, item), { isAccessibilityInfoRequested: !variables.currentIsRequested }) : item;
                // search 쿼리: PlaceListItem[]
                if (Array.isArray(oldData)) {
                    return oldData.map(toggleItem);
                }
                // PlaceListDetail 쿼리: { placeList, places: PlaceListItem[] }
                const wrapper = oldData;
                if (wrapper.places) {
                    return Object.assign(Object.assign({}, wrapper), { places: wrapper.places.map(toggleItem) });
                }
                return oldData;
            });
            return {
                previousSearchData,
            };
        }),
        onSuccess: (_data, variables) => {
            if (!variables.currentIsRequested) {
                ToastUtils.show('정보가 등록되면 알림을 보내드릴게요 🔔');
            }
            else {
                ToastUtils.show('정보 요청이 취소되었어요');
            }
            queryClient.invalidateQueries({
                queryKey: ['PlaceDetailV2', variables.placeId],
            });
        },
        onError: (error, variables, context) => {
            ToastUtils.showOnApiError(error);
            if ((context === null || context === void 0 ? void 0 : context.previousSearchData) &&
                variables.searchQueryKey !== undefined) {
                queryClient.setQueryData(variables.searchQueryKey, context.previousSearchData);
            }
        },
    });
    const safeMutate = (args) => {
        if (isPending)
            return;
        mutate(Object.assign(Object.assign({}, args), { searchQueryKey: listQueryKey !== null && listQueryKey !== void 0 ? listQueryKey : [
                'search',
                {
                    text,
                    location,
                    sortOption,
                    scoreUnder,
                    hasSlope,
                    isRegistered,
                    useCameraRegion,
                    searchMode,
                },
            ] }));
    };
    return safeMutate;
}
